// extracted by mini-css-extract-plugin
export default {"details":"Details_details__4T-rF","announcement":"Details_announcement__h32Lh","date":"Details_date__vNwtN","location":"Details_location__96lrq","hashtag":"Details_hashtag__2yiTu"};